// extracted by mini-css-extract-plugin
export default {"EditUser":"styles_EditUser__bsvge","col":"styles_col__mPPlS","footer":"styles_footer__wU32t","prevIcon":"styles_prevIcon__OAra6","nextIcon":"styles_nextIcon__CMCgO"};